import { css } from "@emotion/css";

import { Theme } from "@/modules/theme/utils/createTheme";

export function createChangePasswordFormStyles({ spacing }: Theme) {
  return {
    buttonWrapper: css({
      display: "flex",
      justifyContent: "flex-end",
    }),
    button: css({
      minWidth: 156,
    }),
    formContentWrapper: css({
      margin: spacing([0, -1]),
    }),
  };
}
